import React from 'react'
import Sidebar from './Sidebar'
const AddUserContainer = () => {
  return (
    <div className='mt-3'>
    <Sidebar/>
    </div>
  )
}

export default AddUserContainer